import { useNavigate } from 'react-router-dom';
import '../styles/NotFound.scss';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="not-found">
      <svg viewBox="0 0 400 300" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M200 50C122.5 50 60 112.5 60 190C60 267.5 122.5 330 200 330C277.5 330 340 267.5 340 190C340 112.5 277.5 50 200 50ZM200 290C144.5 290 100 245.5 100 190C100 134.5 144.5 90 200 90C255.5 90 300 134.5 300 190C300 245.5 255.5 290 200 290Z"
          fill="#E0E0E0"
        />
        <path
          d="M200 120C177.5 120 160 137.5 160 160C160 182.5 177.5 200 200 200C222.5 200 240 182.5 240 160C240 137.5 222.5 120 200 120Z"
          fill="#E0E0E0"
        />
        <path
          d="M200 220C177.5 220 160 237.5 160 260C160 282.5 177.5 300 200 300C222.5 300 240 282.5 240 260C240 237.5 222.5 220 200 220Z"
          fill="#E0E0E0"
        />
      </svg>
      <h1>404 - Page Not Found</h1>
      <p>The page you are looking for doesn't exist or has been moved.</p>
      <button className="go-home-btn" onClick={() => navigate('/')}>
        Go Back Home
      </button>
    </div>
  );
};

export default NotFound;
